// extracted by mini-css-extract-plugin
export default {"wrapper":"Ly-z","viewport":"My-z","container":"Ny-z","slide":"Oy-z"};